import React, { useEffect } from "react";

import "./HorizontalScroller_Individual.css";
import { ScrollView } from "react-native";

import {
  PostNavigatingTawkPill,
  PostNavigatingTawkPillConfig,
  postNavigatingTawkPillDemoProps1,
} from "../../Components/PostNavigatingTawkPill/PostNavigatingTawkPill";
import { tawksColorsWithCharacteristicHue } from "../../Infrastucture/TawkitColorsProvider";

export interface HomePageHorizontalScrollerConfig {
  preferredPillConfig: PostNavigatingTawkPillConfig | null;
  tawkPillConfigs: PostNavigatingTawkPillConfig[];
  offsetLevel: number;
}

const whatIsTawkitConfig: PostNavigatingTawkPillConfig = {
  tawkPillConfig: {
    tawkTitle: "What is tawkit?",
    authorProfilePicConfig: {
      kind: "CloudinaryImageConfig",
      publicId: "ProfilePictures/default",
    },
    authorUserHandle: "atai",
    colorsProvider: tawksColorsWithCharacteristicHue(0.1),
    durationDescription: "0:42",
    isClip: false,
    size: "big",
  },
  postId: "4663fd4b-f2cf-4215-a52b-4791175fa52b",
};

export const homePageHorizontalScrollerDemoProps0: HomePageHorizontalScrollerConfig =
  {
    preferredPillConfig: whatIsTawkitConfig,
    tawkPillConfigs: [
      postNavigatingTawkPillDemoProps1,
      postNavigatingTawkPillDemoProps1,
      postNavigatingTawkPillDemoProps1,
      postNavigatingTawkPillDemoProps1,
      postNavigatingTawkPillDemoProps1,
    ],
    offsetLevel: 0,
  };

export const homePageHorizontalScrollerDemoProps1: HomePageHorizontalScrollerConfig =
  {
    preferredPillConfig: null,
    tawkPillConfigs: [
      postNavigatingTawkPillDemoProps1,
      postNavigatingTawkPillDemoProps1,
      postNavigatingTawkPillDemoProps1,
      postNavigatingTawkPillDemoProps1,
      postNavigatingTawkPillDemoProps1,
    ],
    offsetLevel: 1,
  };

export const homePageHorizontalScrollerDemoProps2: HomePageHorizontalScrollerConfig =
  {
    preferredPillConfig: null,
    tawkPillConfigs: [
      postNavigatingTawkPillDemoProps1,
      postNavigatingTawkPillDemoProps1,
      postNavigatingTawkPillDemoProps1,
      postNavigatingTawkPillDemoProps1,
      postNavigatingTawkPillDemoProps1,
    ],
    offsetLevel: 2,
  };

function preferredPill(
  props: HomePageHorizontalScrollerConfig
): JSX.Element | null {
  if (props.preferredPillConfig) {
    return (
      <div className="HomePageHorizontalScroller_PreferredPillItself">
        <PostNavigatingTawkPill {...props.preferredPillConfig} />
      </div>
    );
  }
  return null;
}

export function HomePageHorizontalScroller(
  props: HomePageHorizontalScrollerConfig
): JSX.Element {
  const tawkPillWrapperClassName =
    props.preferredPillConfig == null
      ? "HomePageHorizontalScroller_PillContainer"
      : "HomePageHorizontalScroller_PillContainer_Preferred";
  const tawkPills = props.tawkPillConfigs.map((tawkPillConfig) => (
    <div className={tawkPillWrapperClassName}>
      <div className="HomePageHorizontalScroller_AbovePillSpacer" />
      <PostNavigatingTawkPill {...tawkPillConfig} />
    </div>
  ));

  const scrollViewRef = React.createRef<ScrollView>();
  const scrollView = (
    <ScrollView
      showsHorizontalScrollIndicator={false}
      horizontal
      ref={scrollViewRef}
    >
      {preferredPill(props)}
      {tawkPills}
    </ScrollView>
  );

  useEffect(() => {
    let xOffset = 0;
    if (props.offsetLevel === 1) {
      xOffset = 100;
    }
    if (props.offsetLevel === 2) {
      xOffset = 50;
    }
    scrollViewRef.current?.scrollTo({ x: xOffset, animated: false });
  }, []);

  return scrollView;
}
